export const base = '/admin';
export const newUser = `${base}/adduser`;
export const pricing = `${base}/pricing`;
export const costs = `${pricing}/costs`;
export const userList = `${base}/users`;
export const preferences = `${base}/preferences`;
